module.exports = __webpack_public_path__ + "img/banner4.0cb9786f.jpg";